var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3TableLampOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7v62h62V7H7zm47 51v7H22v-7h32zm11 7h-7v-7h5v-4H44v-3h-4V40h9l-6.72-13h-8.56L27 40h9v11h-4v3H14v4h4v7h-7V11h54v54z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_Table_lamp_off.a0603a77.svg";
export { SvgA3TableLampOff as ReactComponent };